import React, { useEffect } from 'react';

export default function Checkout() {
  useEffect(() => {
    document.title = "Commande | Tv Plux";
    // Re-initialize jQuery/Swiper plugins after React renders
    if (window.$ && window.$.fn.waypoint) {
      window.$(window).trigger('resize');
    }
    // Re-init Swiper if available
    if (window.Swiper) {
      const swiperEl = document.querySelector('.card__content');
      const swiperFeed = document.querySelector('.card__content_feed');
      if (swiperEl && !swiperEl.swiper) {
        new window.Swiper('.card__content', {
          loop: true, autoplay: { delay: 600 }, centeredSlides: true,
          pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
          breakpoints: { 320: { slidesPerView: 2, spaceBetween: 10 }, 480: { slidesPerView: 2, spaceBetween: 10 }, 640: { slidesPerView: 5, spaceBetween: 15 } }
        });
      }
      if (swiperFeed && !swiperFeed.swiper) {
        new window.Swiper('.card__content_feed', {
          loop: true, autoplay: { delay: 2500 }, centeredSlides: true,
          pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
          breakpoints: { 320: { slidesPerView: 1, spaceBetween: 10 }, 480: { slidesPerView: 1, spaceBetween: 10 }, 640: { slidesPerView: 1, spaceBetween: 15 } }
        });
      }
    }
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: `<div class="flex flex-col items-center text-center px-4">
    <!-- Spinner (caché au départ comme dans la version NL) -->
    <div id="loader" class="hidden mb-6">
      <svg class="animate-spin h-10 w-10 text-[#635bff]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
      </svg>
    </div>

    <h2 id="loading-text" class="text-lg font-medium text-gray-900">
      Veuillez patienter, nous chargeons votre page de paiement…
    </h2>
    <p class="text-sm text-gray-500 mt-2">
      Vous allez être redirigé automatiquement vers une page sécurisée.
    </p>
  </div>` }} />
  );
}
